import { useEffect, useState } from "react";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import { API } from "../../lib/api";
import { CARDS } from "./Industries";

export const Hero = ({ openForm }) => {
  const [stats, setStats] = useState({ states: 36, districts: 727 });
  useEffect(() => {
    axios.get(`${API}/stats`).then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const STATS = [
    { id: "states", value: stats.states, label: "States & UTs" },
    { id: "districts", value: stats.districts, label: "Districts" },
    { id: "categories", value: 3, label: "Service categories" },
    { id: "sectors", value: 6, label: "Industry sectors" },
  ];

  return (
    <section id="top" className="keep-dark relative overflow-hidden bg-[#0B1120]">
      <div className="grid-bg pointer-events-none absolute inset-0 opacity-40" />
      <div className="relative mx-auto grid max-w-6xl grid-cols-1 gap-8 px-4 pb-12 pt-10 sm:px-6 lg:grid-cols-12 lg:gap-8 lg:px-8 lg:pb-16 lg:pt-14">
        <div className="lg:col-span-7">
          <p className="eyebrow rise" style={{ animationDelay: "0ms" }}>All-India B2B Manpower Aggregator</p>
          <h1 data-testid="hero-headline" className="rise mt-4 font-heading text-3xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-4xl lg:text-[2.75rem]" style={{ animationDelay: "80ms" }}>
            Guards, skilled hands &amp; site labour.<br />
            <span className="text-orange-500">Verified. Deployed. Ledgered.</span>
          </h1>
          <p className="rise mt-5 max-w-xl text-sm leading-relaxed text-slate-300 lg:text-base" style={{ animationDelay: "160ms" }}>
            Balangir Group connects factories, mills, malls, multiplexes and construction sites with security personnel and skilled or unskilled employees — with masked contacts, wallet billing and OTP-confirmed joining.
          </p>
          <div className="rise mt-7 flex flex-col gap-3 sm:flex-row" style={{ animationDelay: "240ms" }}>
            <button data-testid="hero-cta-employer" onClick={() => openForm("employer")}
              className="group inline-flex h-11 items-center justify-center gap-2 rounded-lg bg-orange-500 px-6 text-sm font-semibold text-white transition-colors hover:bg-orange-600 hover:text-white">
              Hire Workforce <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </button>
            <button data-testid="hero-cta-worker" onClick={() => openForm("worker")}
              className="inline-flex h-11 items-center justify-center gap-2 rounded-lg border border-white/20 px-6 text-sm font-semibold text-white transition-colors hover:border-orange-500 hover:text-orange-300">
              Find Work Near You
            </button>
          </div>
          <dl className="rise mt-7 grid grid-cols-2 gap-2.5 sm:grid-cols-4" style={{ animationDelay: "320ms" }}>
            {STATS.map((s) => (
              <div key={s.id} data-testid={`hero-stat-${s.id}`} className="flex flex-col items-center justify-center rounded-xl border border-white/15 bg-white/5 px-2 py-3 text-center">
                <dt className="font-heading text-2xl font-extrabold text-orange-400">{s.value}</dt>
                <dd className="mt-0.5 whitespace-nowrap text-xs font-medium text-slate-200">{s.label}</dd>
              </div>
            ))}
          </dl>
        </div>
        <HeroVisual />
      </div>
    </section>
  );
};

const Tile = ({ c, className }) => (
  <a href="#industries" data-testid={`hero-industry-${c.key}`} className={`group relative block overflow-hidden rounded-xl ${className}`}>
    <img src={c.img} alt={c.title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
    <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(11,27,63,.9) 0%, rgba(11,27,63,.3) 50%, rgba(11,27,63,0) 80%)" }} />
    <div className="absolute bottom-0 left-0 right-0 p-3">
      <p className="font-heading text-sm font-bold leading-tight text-white">{c.title}</p>
      <span className="mt-1 inline-block rounded-full bg-orange-500 px-2 py-0.5 text-[10px] font-medium text-white">{c.sub}</span>
    </div>
  </a>
);

const HeroVisual = () => (
  <div data-testid="hero-industries" className="grid h-[300px] grid-cols-2 grid-rows-2 gap-3 lg:col-span-5 lg:h-[340px] lg:self-center">
    <Tile c={CARDS[0]} className="row-span-2" />
    <Tile c={CARDS[1]} />
    <Tile c={CARDS[2]} />
  </div>
);
